import { Order } from 'shell/view-models/order';
import { paginationListToQueryStringForBatchAndEventManager } from 'system/utils/event-batch/list-object-to-query-string-batch-event';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormPublishedEvents } from './types';

export const transformDataset = (values: FiltersFormPublishedEvents): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    aDataOra: {
      value: otherValues?.dateTimePublicationTo?.toFormat(`yyyy-MM-dd'T'HH:mm:ss`) || '',
    },
    codiceTipoEvento: {
      value: otherValues.typeEventCode,
    },
    daDataOra: {
      value: otherValues?.dateTimePublicationFrom?.toFormat(`yyyy-MM-dd'T'HH:mm:ss`) || '',
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    id: ordersToTransform.id,
    codiceTipoEvento: ordersToTransform.typeEventCode,
    dataOraPubblicazione: ordersToTransform.dataTimePublication,
  };

  return `${paginationListToQueryStringForBatchAndEventManager({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
